import { Routes } from '@angular/router';
import { Type } from '@angular/core';

import { ContentOverviewGuard } from './guards/content-overview.guard';
import { ContentPageDetailGuard } from './guards/content-page-detail.guard';
import { ContentPageMetaGuard } from './guards/content-page-meta.guard';

export function createContentRoutes(contentType: string, loadDetailComponent: () => Promise<Type<unknown>>): Routes {
  return [
    {
      path: '',
      pathMatch: 'full',
      loadComponent: () => import('./containers/content-overview/content-overview.component').then(m => m.ContentOverviewComponent),
      runGuardsAndResolvers: 'paramsOrQueryParamsChange',
      canActivate: [ContentOverviewGuard],
      canDeactivate: [ContentOverviewGuard],
      data: {
        contentType,
        logoClass: 'type--content',
        breadcrumb: {
          skip: true,
        },
      },
    },
    {
      path: ':pageId/:target',
      loadComponent: loadDetailComponent,
      canActivate: [ContentPageDetailGuard, ContentPageMetaGuard],
      data: {
        contentType,
        logoClass: 'type--content',
        breadcrumb: {
          label: ':target',
        },
      },
    },
    {
      path: ':parentPage/:parentTarget/:pageId/:target',
      loadComponent: loadDetailComponent,
      canActivate: [ContentPageDetailGuard],
      data: {
        contentType,
        logoClass: 'type--content',
        breadcrumb: {
          label: ':parentTarget/:target',
        },
      },
    },
  ];
}
